module.exports = __webpack_public_path__ + "brankic.06cba358211d2a4ef013.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/brankic.eot
// module id = 89
// module chunks = 2